import React from 'react'
import PlanDeEmbarque from '../../../models/embarque/plan_de_embarque'
import { FORM_PLAN_DE_EMBARQUE } from '../../../config/forms'
import { getFormValues, reset } from 'redux-form'
import { actualizarDatosParaMuiTable, saveFechaReferenciaPlanDeEmbarque } from './TablaBuquesAnunciadosActions'
import { COLUMNS, COLUMNS_PLAN_DE_EMBARQUE_ACTIVO } from './constantesPlanDeEmbarque'
import { COLUMNS_BODEGAS_BUQUE } from './constantesBuque'
import { TABLA_PLAN_DE_EMBARQUE, TABLA_BODEGA_BUQUE, TABLA_PLAN_DE_EMBARQUE_ACTIVO } from '../../../config/tables'
import { toast } from 'react-toastify'
import DialogView from '../../Dialogos/DialogView'
import { DialogConfirmacionContent } from '../../Dialogos/DialogConfirmacionContent'
import Buque from '../../../models/buque/buque'
import DialogoEdicionPlanDeEmbarqueBodega from '../components/planDeEmbarque/DialogoEdicionPlanDeEmbarqueBodega'

export function resetFormPlanDeEmbarqueBodega () {
  return (dispatch) => {
    dispatch(reset(FORM_PLAN_DE_EMBARQUE))
    dispatch({ type: 'REQUEST_CEREAL_VARIEDADES' })
  }
}

export function deleteDellatePlanDeEmbarqueBodega (fecha, bodega, buque, paisDestino) {
  return (dispatch) => {
    return PlanDeEmbarque.deletePlanDeEmbarqueBodega(fecha, bodega, buque, paisDestino)
      .then((response) => {
        console.log(response)
        if (!response.error) {
          toast.success('Detalle de bodega de plan de embarque eliminado correctamente')
          dispatch(obtenerDatosPlanDeEmbarqueBodegas(fecha))
        } else {
          toast.error('Error al intentar eliminar detalle de bodega de plan de embarque')
        }
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al intentar eliminar detalle de bodega de plan de embarque')
      })
  }
}

export function deleteDellatePlanDeEmbarqueBodegaCompleto (fecha, buque) {
  return (dispatch) => {
    return PlanDeEmbarque.deletePlanDeEmbarqueBodegaCompleto(fecha, buque)
  }
}
export function updateDetalleBodega (fecha, bodega, buque, paisDestino) {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_PLAN_DE_EMBARQUE)(state)
    return PlanDeEmbarque.updatePlanDeEmbarqueBodega(fecha, bodega, buque, paisDestino, formValues)
      .then((response) => {
        if (!response.error) {
          toast.success('Detalle de bodega de plan de embarque modificado correctamente. ')
          dispatch(resetFormPlanDeEmbarqueBodega())
        } else {
          console.log(response.message)
          toast.error('Error al intentar modificar detalle de bodega de plan de embarque')
          dispatch(resetFormPlanDeEmbarqueBodega())
        }
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al intentar modificar detalle de bodega de plan de embarque')
        dispatch(resetFormPlanDeEmbarqueBodega())
      })
  }
}

export function openEdicionDetalleBodegaDialog (fecha, bodega, buque, paisDestino) {
  return (dispatch, getState) => {
    const confirmCallback = () => {
      updateDetalleBodega(fecha, bodega, buque, paisDestino)(dispatch, getState)
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'EDICION_DETALLE_BODEGA'
      })
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'EDICION_DETALLE_BODEGA_CEREAL_CHANGE'
      })
      dispatch({ type: 'CLOSE_EDICION_DETALLE_BODEGA' })
    }
    const cancelCallback = () => {
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'EDICION_DETALLE_BODEGA_CEREAL_CHANGE'
      })
      dispatch({
        type: 'CLOSE_DIALOG',
        id: 'EDICION_DETALLE_BODEGA'
      })
      dispatch({ type: 'CLOSE_EDICION_DETALLE_BODEGA' })
    }
    const confirmCerealChange = () => {
      dispatch({
        type: 'OPEN_DIALOG',
        id: 'EDICION_DETALLE_BODEGA_CEREAL_CHANGE',
        maxWidth: 'sm',
        content: <DialogView
          confirmCallback={confirmCallback}
          cancelCallback={cancelCallback}
          content={<DialogConfirmacionContent
            message='La edicion del cereal y su variedad se aplicara a toda la bodega'
          />
          }
        />
      })
    }
    dispatch({
      type: 'OPEN_DIALOG',
      id: 'EDICION_DETALLE_BODEGA',
      maxWidth: 'md',
      content:
  <DialogoEdicionPlanDeEmbarqueBodega
    confirmCallback={confirmCallback}
    cancelCallback={cancelCallback}
    confirmCerealChange={confirmCerealChange}
    fechaDeReferencia={fecha}
    bodega={bodega}
  />
    })
    dispatch({
      type: 'OPEN_DETALLE_BODEGA'
    })
  }
}

export function getPlanDeEmbarque (fecha) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_PLAN_DE_EMBARQUE' })
    return PlanDeEmbarque.obtenerPlanDeEmbarque(fecha)
      .then((data) => {
        dispatch({ type: 'RECEIVE_PLAN_DE_EMBARQUE', data })
      })
  }
}

export function submitPlanDeEmbarque (anuncio) {
  return (dispatch) => {
    const fechaEstimadaArribo = new Date(anuncio.fechaEstimadaDeArriboDesde).toLocaleDateString()
    return PlanDeEmbarque.insertarPlanDeEmbarque(anuncio, fechaEstimadaArribo)
      .then((response) => {
        const fechaDeReferencia = response.fechaDeReferencia
        console.log('fechaDeReferencia ', fechaDeReferencia)
        if (response.fechaDeReferencia) {
          return saveFechaReferenciaPlanDeEmbarque(anuncio.fechaAnuncio, fechaDeReferencia)
            .then(() => {
              dispatch({ type: 'PLAN_DE_EMBARQUE' })
              toast.success('Plan de embarque generado correctamente')
              dispatch(actualizarDatosParaMuiTable())
            })
            .catch(error => {
              console.log(error)
              toast.error('Error al intentar generar plan de embarque')
            })
        } else {
          console.log(response.error)
          toast.error('Error al intentar generar plan de embarque')
        }
      })
      .catch(error => {
        console.log(error)
        toast.error('Error al intentar generar plan de embarque')
      })
  }
}

function parseDataBodegas (data) {
  const parsedData = []
  for (const entry of data) {
    parsedData.push({ ...entry, detalle: entry })
  }
  return parsedData
}

export function updateTablaBodegasBuque (buque) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_BODEGA_BUQUE
    })

    return Buque.obtenerBodegasBuque(buque)
      .then((data) => {
        dispatch({ type: 'RECEIVE_BODEGAS_BUQUE', data })
        const d = parseDataBodegas(data)
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS_BODEGAS_BUQUE,
            data: d,
            title: 'Bodegas de buque',
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: { customToolbar: null, print: false, pagination: false, download: false, filter: false, search: false, viewColumns: false }
          },
          id: TABLA_BODEGA_BUQUE
        })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function submitPlanDeEmbarqueBodega () {
  return (dispatch, getState) => {
    const state = getState()
    const formValues = getFormValues(FORM_PLAN_DE_EMBARQUE)(state)
    console.log('formValues ', formValues)
    return PlanDeEmbarque.insertarPlanDeEmbarqueBodega(formValues)
      .then((response) => {
        if (!response.error) {
          toast.success('Detalle de bodega guardado correctamente')
          dispatch(obtenerDatosPlanDeEmbarqueBodegas(formValues.fechaDeReferencia))
          dispatch(resetFormPlanDeEmbarqueBodega())
        } else {
          if (response.message) {
            const message = response.message.split('CONTEXT')
            toast.error(message[0])
          } else {
            toast.error('Error al intentar cargar detalle de bodega')
          }
          dispatch(resetFormPlanDeEmbarqueBodega())
        }
      })
      .catch((e) => {
        console.log(e)
        toast.error('Error al intentar cargar detalle de bodega')
        dispatch(resetFormPlanDeEmbarqueBodega())
      })
  }
}

export function parseData (data) {
  const parsedData = []
  for (const entry of data) {
    parsedData.push({ ...entry, detalleBodega: entry })
  }
  return parsedData
}

export function obtenerDatosPlanDeEmbarqueBodegas (fecha) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_PLAN_DE_EMBARQUE
    })
    PlanDeEmbarque.getPlanDeEmbarqueBodega(fecha).then(callback)
    function callback (d) {
      dispatch({ type: 'RECEIVE_PLAN_DE_EMBARQUE_BODEGA', d })
      const data = parseData(d)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS,
          data: data,
          title: 'Detalle de plan de embarque',
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar: null, print: false, pagination: false, download: false, filter: false, search: false, viewColumns: false }
        },
        id: TABLA_PLAN_DE_EMBARQUE
      })
    }
  }
}

/**
  * Elimina plan de embarque
  * Primero elimina los detalles de bodega, despues el plan de embarque y
  * por ultimo cambia a null la fecha de plan de embarque en line_up_buque
  * @param fechaReferencia
  * @param buque identifican el plan de embarque y detalle de bodega a eliminar
  * @param fechaAnuncio identifica el anuncio a modificar en line_up_buques
  *
**/
export function eliminarPlanDeEmbarque (fechaReferencia, buque, fechaAnuncio) {
  return (dispatch) => {
    return PlanDeEmbarque.deletePlanDeEmbarqueBodegaCompleto(fechaReferencia, buque)
      .then((response) => {
        if (!response.error) {
          return PlanDeEmbarque.deletePlanDeEmbarque(fechaReferencia, buque)
            .then((response) => {
              if (!response.error) {
                return saveFechaReferenciaPlanDeEmbarque(fechaAnuncio)
                  .then(() => {
                    dispatch({ type: 'ELIMINAR_PLAN_DE_EMBARQUE' })
                    toast.success('Plan de embarque eliminado correctamente.')
                    dispatch(actualizarDatosParaMuiTable())
                  })
                  .catch((e) => {
                    console.log(e)
                  })
              } else {
                console.log(response.message)
                toast.error('Error al intentar eliminar plan de embarque')
              }
            })
            .catch((e) => {
              console.log(e)
            })
        } else {
          console.log(response)
          toast.error('Error al intentar eliminar plan de embarque')
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function getDetalleBodega (fecha, bodega) {
  return (dispatch) => {
    return PlanDeEmbarque.obtenerDetalleBodega(fecha, bodega)
      .then((data) => {
        dispatch({ type: 'RECEIVE_DETALLE_BODEGA', data })
      })
      .catch((e) => {
        console.log(e)
        toast.error('Error al buscar detalle de bodega')
      })
  }
}

export function obtenerBodegasBuque (buque) {
  return (dispatch) => {
    dispatch({ type: 'REQUEST_BODEGAS_BUQUE' })
    return Buque.obtenerBodegasBuque(buque)
      .then((data) => {
        dispatch({ type: 'RECEIVE_BODEGAS_BUQUE', data })
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function submitBodegaBuque (buque, numero) {
  return (dispatch) => {
    return Buque.insertarBodegaBuque(buque, numero)
      .then(() => {
        dispatch({ type: 'INSERT_BODEGA_BUQUE' })
        dispatch(updateTablaBodegasBuque(buque))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function eliminarBodegaBuque (buque, bodega) {
  return (dispatch) => {
    return Buque.deleteBodegaBuque(buque, bodega)
      .then((result) => {
        console.log(result)
        dispatch({ type: 'DELETE_BODEGA_BUQUE' })
        dispatch(updateTablaBodegasBuque(buque))
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

export function obtenerDatosPlanDeEmbarqueActivo (titleColor = null) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_PLAN_DE_EMBARQUE_ACTIVO
    })

    PlanDeEmbarque.obtenerPlanDeEmbarqueActivo().then(callback)
    function callback (data) {
      const customToolbar = null
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_PLAN_DE_EMBARQUE_ACTIVO,
          data: data,
          title: 'Plan de embarque activo',
          isLoading: false,
          titleColor: titleColor,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            pagination: false,
            viewColumns: false,
            search: false,
            download: false,
            tableBodyMaxHeight: '450px',
            print: false,
            filter: false
          }
        },
        id: TABLA_PLAN_DE_EMBARQUE_ACTIVO
      })
    }
  }
}
